// This file is the entry point for the product page. It is used to import files required for the product page only and should not import files intended to be used globally.

// Product Entrypoint

//Helpers
import { loadComponentIfNeeded } from "@/js/helpers/load-component-if-needed";

//Components
import "@/js/components/swatch-hover";
import "@/js/components/variant-url-image-handler";
import "@/js/components/media-overlay";
import PDPSellingPlan from "@/js/components/pdp-selling-plan";

customElements.define("pdp-selling-plan", PDPSellingPlan);

// Load product-specific components only when needed
// Note: pickup-locations component is now defined inline in snippets/pickup-locations.liquid
// Note: pdp-quantity-breaks is now defined inline in blocks/pdp-quantity-breaks.liquid
// Note: pdp-frequently-bought-together is now defined inline in blocks/pdp-frequently-bought-together.liquid
loadComponentIfNeeded("pdp-zoom-hint", "pdp-zoom-hint", () => import("@/js/components/pdp-zoom-hint"));
